import { RouterProvider } from "react-router-dom";
import { Routing } from "router/routing";
import classes from "App.module.css"
import "global.css"

function App() {
  const routing = Routing()
  return (
    <div className={classes.app}>
      <RouterProvider router={routing} />
    </div>
  );
}

export default App;
